import { FormikErrors } from 'formik'
import { defaultValidators } from '$utils/formValidators'
import { LoginInfo } from './Login.model'

export const validateEmail = (email: string) => {
  if (!defaultValidators.required(email)) {
    return 'Email obligatorio'
  }

  if (!defaultValidators.isValidEmail(email)) {
    return 'El email no es valido'
  }

  return undefined
}

export const validatePassword = (password: string) => {
  if (!defaultValidators.required(password)) {
    return 'Contraseña obligatoria'
  }

  return undefined
}

export const validateFieldForm = (formValueFields: LoginInfo) => {
  let error
  let errors: FormikErrors<LoginInfo> = {}

  error = validateEmail(formValueFields.email)
  if (error) errors.email = error
  error = validatePassword(formValueFields.password)
  if (error) errors.password = error

  return errors
}



// WEBPACK FOOTER //
// ./src/views/Login/Login.validators.ts